import { QueryClient } from '@tanstack/react-query'

import { OPEN_CONTENT_ACCESS_STATUS } from '@hooks/useGetContentAccessStatus'
import { setCustomVariables } from '@components/Piano/utils'

const updatePianoExperience = ({
  isTiunSessionActive,
  queryClient,
}: {
  isTiunSessionActive: boolean
  queryClient: QueryClient
}) => {
  queryClient.setQueryData(['tiun-session-state'], {
    isTiunSessionActive,
  })
  queryClient.invalidateQueries({
    queryKey: ['tiun-session-state'],
    exact: true,
  })

  setCustomVariables({ isTiunSessionActive: `${isTiunSessionActive}` })
  window?.tp?.experience?.execute?.()

  if (isTiunSessionActive) {
    updateTiunSnippet(queryClient, false)
    queryClient.setQueryData(
      ['content-access-status'],
      OPEN_CONTENT_ACCESS_STATUS,
    )
    queryClient.invalidateQueries({
      queryKey: ['content-access-status'],
      exact: true,
    })
  }
}

const updateTiunSnippet = (queryClient: QueryClient, state: boolean) => {
  queryClient.setQueryData(['show-tiun-snippet'], state)
  queryClient.invalidateQueries({
    queryKey: ['show-tiun-snippet'],
    exact: true,
  })
}

const updateUserConnectedState = (queryClient: QueryClient, state: boolean) => {
  queryClient.setQueryData(['is-user-connected-with-tiun'], state)
  queryClient.invalidateQueries({
    queryKey: ['is-user-connected-with-tiun'],
    exact: true,
  })
}

export { updatePianoExperience, updateTiunSnippet, updateUserConnectedState }
